var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0001 6.10156C23.2388 6.10156 23.4677 6.19638 23.6365 6.36517C23.8053 6.53395 23.9001 6.76287 23.9001 7.00156V15.0016C23.9001 15.2403 23.8053 15.4692 23.6365 15.638C23.4677 15.8067 23.2388 15.9016 23.0001 15.9016C22.7614 15.9016 22.5325 15.8067 22.3637 15.638C22.1949 15.4692 22.1001 15.2403 22.1001 15.0016V9.17356L9.1721 22.1016H15.0001C15.2388 22.1016 15.4677 22.1964 15.6365 22.3652C15.8053 22.5339 15.9001 22.7629 15.9001 23.0016C15.9001 23.2403 15.8053 23.4692 15.6365 23.638C15.4677 23.8067 15.2388 23.9016 15.0001 23.9016H7.0001C6.7614 23.9016 6.53248 23.8067 6.3637 23.638C6.19492 23.4692 6.1001 23.2403 6.1001 23.0016V15.0016C6.1001 14.8834 6.12338 14.7663 6.16861 14.6571C6.21384 14.548 6.28013 14.4487 6.3637 14.3652C6.44727 14.2816 6.54649 14.2153 6.65568 14.1701C6.76488 14.1248 6.88191 14.1016 7.0001 14.1016C7.11829 14.1016 7.23532 14.1248 7.34451 14.1701C7.45371 14.2153 7.55292 14.2816 7.63649 14.3652C7.72007 14.4487 7.78636 14.548 7.83159 14.6571C7.87682 14.7663 7.9001 14.8834 7.9001 15.0016V20.8296L20.8281 7.90156H15.0001C14.7614 7.90156 14.5325 7.80674 14.3637 7.63796C14.1949 7.46918 14.1001 7.24026 14.1001 7.00156C14.1001 6.76287 14.1949 6.53395 14.3637 6.36517C14.5325 6.19638 14.7614 6.10156 15.0001 6.10156H23.0001Z",
    fill: "#556060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSize);
export default __webpack_public_path__ + "static/media/size.ac852c55f0f9af6f3e43cbdad39188e6.svg";
export { ForwardRef as ReactComponent };